// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ibn1M","content":"styles_content__3Ffpi"};